import { styled } from 'stitches.config'
import { Collapsible } from 'components/Collapsible'

export const Wrapper = styled('div', {
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  paddingLeft: '$3',
  width: '100%',
  textAlign: 'left',

  '& label': {
    fontWeight: '$semiBold',
    color: '$accent-black',
  },

  '& svg': {
    color: '$accent-black',
  },

  '@bp2': {
    borderRadius: 0,
    fontWeight: '$bold',
    fontSize: '$headline',
    lineHeight: '$headline',
    transition: 'border 0.3s ease-out',
  },
})

export const MenuTrigger = styled(Collapsible.Trigger, {
  cursor: 'pointer',
  margin: 0,
  padding: '$2 $3',
  border: 'none',
  display: 'flex',
  variants: {
    variant: {
      step4: {
        padding: '$2 $1 $2 0',
      },
      productPage: {},
      flexBox: {},
    },
  },
})

export const CollapsibleMenuRoot = styled(Collapsible.Root, {
  backgroundColor: '$accent-white',
  border: '1px solid $tertiary-300',
  borderRadius: '$4',
  overflow: 'hidden',

  variants: {
    variant: {
      step4: {
        borderBottom: '1px solid $accent-gray',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: '0',
      },
      productPage: {},
      flexBox: {},
    },
  },
})

export const Content = styled(Collapsible.Content, {
  color: '$accent-black',
  padding: '0 $3',
  backgroundColor: '$accent-white',
  borderBottomLeftRadius: '$3',
  borderBottomRightRadius: '$3',

  '@bp2': {
    gap: '$3',
  },

  variants: {
    variant: {
      step4: {
        paddingLeft: '0',
      },
      productPage: {},
      flexBox: {},
    },
    hasMaxWidth: {
      true: {
        maxWidth: '380px',
      },
    },
  },
})
